export function uncull(
  pixiCull: any, // pixi-cull main export that is not typed
): void {
  for (const container of pixiCull.containers) {
    for (const object of container.children) {
      object[pixiCull.visible] = true;
    }
  }
}
